export default "__VITE_ASSET__b7c599be__"